import type { IconName } from '../components/Icon';

export interface Social {
  label: string;
  handle: string;
  href: string;
  icon: IconName;
}

/** BYAFT social accounts — shared across all sites (navbar, CTAs, footers). */
export const socials: Social[] = [
  { label: 'TikTok', handle: '@byaft_', href: 'https://www.tiktok.com/@byaft_', icon: 'tiktok' },
  { label: 'Instagram', handle: '@byaft_', href: 'https://www.instagram.com/byaft_/', icon: 'instagram' },
  { label: 'X', handle: '@byaft_', href: 'https://x.com/byaft_', icon: 'x' },
];
